export const sidebarActive = (data) => ({
    type: 'ACTIVE',
    payload: data,
  });